import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// @ts-nocheck
import * as React from 'react';
import IdleTimer from 'react-idle-timer';
import jwtDecode from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { actionsGenerationHelperV2, serialActions, websocketActions } from '@docavenue/core';
import { useCurrentUser } from '../hooks/index';

var _actionsGenerationHel = actionsGenerationHelperV2([{
  resource: 'refresh',
  chunkUrlResource: 'refresh',
  scope: 'auth'
}]),
    _actionsGenerationHel2 = _slicedToArray(_actionsGenerationHel, 1),
    refreshActions = _actionsGenerationHel2[0];

var RefreshToken = function RefreshToken(_ref) {
  var onResetSuccess = _ref.onResetSuccess,
      _ref$resetFactor = _ref.resetFactor,
      resetFactor = _ref$resetFactor === void 0 ? 2 : _ref$resetFactor;
  var tokenInfo = React.useRef({});

  var _ref2 = useCurrentUser() || {},
      token = _ref2.token;

  var dispatch = useDispatch();
  var isCallingApi = React.useRef(false); // This is used for prevent call refresh api a lot when token is nearly expired

  var onAction = React.useCallback(function () {
    if (!tokenInfo.current.token) {
      return;
    }

    var _jwtDecode = jwtDecode(tokenInfo.current.token),
        iat = _jwtDecode.iat,
        exp = _jwtDecode.exp;

    if ((iat + exp) / resetFactor < new Date().getTime() / 1000) {
      if (isCallingApi.current) return;
      isCallingApi.current = true;
      dispatch(serialActions.serial([function () {
        return refreshActions.create({}, {
          isListDst: false
        });
      }, function (state) {
        return onResetSuccess(state);
      }, function () {
        isCallingApi.current = false;
      }]));
    }
  }, [token]);
  React.useEffect(function () {
    if (!!tokenInfo.current.token && !!token && tokenInfo.current.token !== token) {
      dispatch(serialActions.serial([function () {
        return websocketActions.logout();
      }, function () {
        return websocketActions.authenticate();
      }]));
    }

    tokenInfo.current = {
      token: token
    };
  }, [token]);
  return token ? /*#__PURE__*/React.createElement(IdleTimer, {
    onAction: onAction,
    throttle: 500
  }) : null;
};

export default RefreshToken;
//# sourceMappingURL=RefreshToken.js.map